import { render, staticRenderFns } from "./IconSettingsEmbedDomains.vue?vue&type=template&id=13b1809f&"
import script from "./IconSettingsEmbedDomains.vue?vue&type=script&lang=js&"
export * from "./IconSettingsEmbedDomains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13b1809f')) {
      api.createRecord('13b1809f', component.options)
    } else {
      api.reload('13b1809f', component.options)
    }
    module.hot.accept("./IconSettingsEmbedDomains.vue?vue&type=template&id=13b1809f&", function () {
      api.rerender('13b1809f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSettingsEmbedDomains.vue"
export default component.exports